import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-quote-reject',
  templateUrl: './quote-reject.component.html',
  styleUrls: ['./quote-reject.component.scss']
})
export class QuoteRejectComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<QuoteRejectComponent>
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close();
  }
}
